import React, {PropsWithChildren} from 'react';

import './AVDocPreview.scss';
import {Box} from '@mui/material';
import ArrAudioWaveform, {
  ArrAudioWaveformProps,
} from './audio-waveform/ArrAudioWaveform';
import {ArrAVPreviewProvider} from './arr-av-provider/ArrAVPreviewProvider';

const AVDocPreview: React.FC<PropsWithChildren<ArrAudioWaveformProps>> = ({
  children,
  ...props
}: PropsWithChildren<ArrAudioWaveformProps>) => {
  return (
    <ArrAVPreviewProvider>
      <Box className={'av-preview-doc'}>
        <Box className={'av-preview-doc-container'}>
          <ArrAudioWaveform {...props} />
        </Box>
        {children}
      </Box>
    </ArrAVPreviewProvider>
  );
};

export default AVDocPreview;
